import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';
import { NzSegmentedModule, NzSegmentedOption } from 'ng-zorro-antd/segmented';

export type ButtonToggleOption = Omit<NzSegmentedOption, 'useTemplate'>;

@Component({
  selector: 'ui-platform-button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrl: './button-toggle.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NzSegmentedModule,
    TranslocoPipe
  ]
})
export class UiPlatformButtonToggleComponent {
  @Input() set options(options: ButtonToggleOption[]) {
    // We will always need useTemplate because of translate pipe, so there is no reason to let developer always set it
    this.templateOptions = options.map((option: ButtonToggleOption) => ({
      ...option,
      useTemplate: true
    }));
  }

  @Output() optionSelected = new EventEmitter<ButtonToggleOption['value']>();

  @ViewChild('templateRef', { static: true, read: TemplateRef }) templateRef!: TemplateRef<{
    $implicit: NzSegmentedOption;
  }>;

  templateOptions: NzSegmentedOption[] = [];

  onValueChanged(optionIndex: number): void {
    this.optionSelected.emit(this.templateOptions[optionIndex]?.value);
  }
}
